import * as PIXI from "pixi.js";
import UIConfig from "@baseUI/config/UIConfig";

export default new class UICreatorGraphics {
    constructor () {}

    addShadow = (parent, rect, color = 0x000000, alpha = 0.7 ) => {
        const shadow = new PIXI.Graphics()
        shadow.name = 'graphics #8';
        if (!rect){
            rect  = { x: -UIConfig.totalWidth / 2, y: -UIConfig.totalHeight / 2, width : UIConfig.totalWidth, height: UIConfig.totalHeight}
        }
        shadow.interactive = true
        shadow.beginFill(color, alpha)
        shadow.drawRect(rect.x, rect.y, rect.width, rect.height)
        parent.addChild(shadow)
        return shadow
    }

    addLine = (container, x1, y1, x2, y2, width= 4, color = 0xffffff) => {
        const line = new PIXI.Graphics()
        line.name = 'graphics #9';
        line.lineStyle(width, color)
        line.moveTo(x1,y1)
        line.lineTo(x2,y2)
        container.addChild(line)
    }

    addRect = (container, x, y, width, height, color = 0xffffff, alpha = 1) => {
        const rect = new PIXI.Graphics()
        rect.name = 'graphics #10';
        rect.beginFill(color, alpha)
        rect.drawRect(x, y, width, height)
        container.addChild(rect)
    }

    addSeparator = (container, width = 900, size = 4, color = 0xffffff) => {
        const separator = new PIXI.Graphics()
        separator.name = 'graphics #4';
        separator.lineStyle(size, color)
        separator.moveTo(0, 0)
        separator.lineTo(width, 0)
        container.addChild(separator)
        return separator;
    }

}()
